import { useMediaQuery } from "@mui/material";

import {
  GENIE_MIN_DOCKED_WIDTH,
  GENIE_SIDE_BY_SIDE_MIN_VIEWPORT,
} from "./genieDockLayout";

/**
 * Side by side is only offered where Genie and a usable page both fit: by
 * default layout's rail and page; an app that docks Genie itself names the
 * room its page keeps.
 */
export const useCanShowGenieSideBySide = (
  pageReservedWidth?: number
): boolean =>
  useMediaQuery(
    `(min-width: ${
      pageReservedWidth === undefined
        ? GENIE_SIDE_BY_SIDE_MIN_VIEWPORT
        : pageReservedWidth + GENIE_MIN_DOCKED_WIDTH
    }px)`
  );
